const ADMIN_MFA_RESPONSE_FIELDS = `
  status
  challengeToken
  secret
  otpauthUri
  accessToken
  recoveryCodes
  retryAfterSeconds
`;

export const LOGIN_MUTATION = `
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(input: { email: $email, password: $password }) {
      jwtToken
      loginStatus
      mfa { ${ADMIN_MFA_RESPONSE_FIELDS} }
    }
  }
`;

export const COMPLETE_ADMIN_MFA = `
  mutation CompleteAdminMfa($input: CompleteAdminMfaInput!) {
    completeAdminMfa(input: $input) {
      ${ADMIN_MFA_RESPONSE_FIELDS}
    }
  }
`;

export const ADMIN_MFA_SETTINGS = `
  query AdminMfaSettings {
    adminMfaSettings { enabled }
  }
`;

export const BEGIN_ADMIN_MFA_ENROLLMENT = `
  mutation BeginAdminMfaEnrollment($currentPassword: String!) {
    beginAdminMfaEnrollment(currentPassword: $currentPassword) {
      ${ADMIN_MFA_RESPONSE_FIELDS}
    }
  }
`;

export const CANCEL_ADMIN_MFA_ENROLLMENT = `
  mutation CancelAdminMfaEnrollment {
    cancelAdminMfaEnrollment
  }
`;

export const DISABLE_ADMIN_MFA = `
  mutation DisableAdminMfa($input: DisableAdminMfaInput!) {
    disableAdminMfa(input: $input) {
      ${ADMIN_MFA_RESPONSE_FIELDS}
    }
  }
`;

export const CHANGE_ADMIN_PASSWORD = `
  mutation ChangeAdminPassword($currentPassword: String!, $newPassword: String!) {
    changeAdminPassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;

export const LEARNING_LOGIN_MUTATION = `
  mutation LearningLogin($email: String!, $password: String!) {
    learningLogin(input: { email: $email, password: $password }) {
      token
      viewer {
        id
        firstName
        lastName
        organizationId
      }
    }
  }
`;

export const LEARNING_REQUEST_PASSWORD_RESET_MUTATION = `
  mutation LearningRequestPasswordReset($email: String!) {
    learningRequestPasswordReset(email: $email)
  }
`;

export const LEARNING_RESET_PASSWORD_MUTATION = `
  mutation LearningResetPassword($email: String!, $code: String!, $newPassword: String!) {
    learningResetPassword(input: { email: $email, code: $code, newPassword: $newPassword }) {
      token
      viewer {
        id
        firstName
        lastName
        organizationId
      }
    }
  }
`;

export const LEARNING_CHANGE_PASSWORD_MUTATION = `
  mutation LearningChangePassword($currentPassword: String!, $newPassword: String!) {
    learningChangePassword(input: { currentPassword: $currentPassword, newPassword: $newPassword }) {
      token
      viewer {
        id
        firstName
        lastName
        organizationId
      }
    }
  }
`;

export const BEGIN_COMPANY_SIGN_IN = `
  mutation BeginCompanySignIn($email: String, $redirectUri: String) {
    beginCompanySignIn(email: $email, redirectUri: $redirectUri) {
      authorizationUrl
      state
    }
  }
`;

export const COMPLETE_COMPANY_SIGN_IN = `
  mutation CompleteCompanySignIn($input: CompleteCompanySignInInput!) {
    completeCompanySignIn(input: $input) {
      status
      jwtToken
      email
    }
  }
`;
